import {fonts} from '../../../../themes/fonts'

export const fontWeights = {
  default: {
    titleXS: fonts.weight.lg,
    titleS: fonts.weight.lg,
    titleM: fonts.weight.lg,
    titleL: fonts.weight.lg,
    titleXL: fonts.weight.lg,
    title2XL: fonts.weight.lg,
    title3XL: fonts.weight.lg,
    title4XL: fonts.weight.lg,
    title5XL: fonts.weight.xl,
    bodyXS: fonts.weight.sm,
    bodyS: fonts.weight.sm,
    bodyM: fonts.weight.sm,
    bodyL: fonts.weight.sm,
    labelXS: fonts.weight.md,
    labelS: fonts.weight.md,
    labelM: fonts.weight.md
  }
}

export const letterSpacingAdjust = {
  default: {
    bodyXS: '0.01em',
    bodyS: '0.01em',
    bodyM: '0.01em',
    bodyL: '0.01em',
    labelXS: '0.01em',
    labelS: '0.01em',
    labelM: '0.01em',
    titleXS: '0.01em',
    titleS: '0.01em',
    titleM: '0.01em',
    titleL: '0.01em',
    titleXL: 'normal',
    title2XL: 'normal',
    title3XL: 'normal',
    title4XL: 'normal',
    title5XL: '-0.01em'
  }
}

export const languageFontSettings = {
  ar: {
    fontFamily: 'Noto Sans Arabic',
    letterSpacingAdjust: {
      bodyXS: '-0.25px',
      bodyS: '-0.25px',
      bodyM: '-0.25px',
      bodyL: '-0.5px',
      labelXS: '-0.25px',
      labelS: '-0.25px',
      labelM: '-0.25px',
      titleXS: '-0.25px',
      titleS: '-0.25px',
      titleM: '-0.25px',
      titleL: '-0.5px',
      titleXL: '-0.5px',
      title2XL: '-0.5px',
      title3XL: '-0.5px',
      title4XL: '-0.5px',
      title5XL: '-0.5px'
    }
  },
  el: {
    fontFamily: 'Noto Sans',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  he: {
    fontFamily: 'Noto Sans Hebrew',
    letterSpacingAdjust: {
      bodyXS: '-0.15px',
      bodyS: '-0.15px',
      bodyM: '-0.15px',
      bodyL: '-0.5px',
      labelXS: '-0.15px',
      labelS: '-0.15px',
      labelM: '-0.15px',
      titleXS: '-0.15px',
      titleS: '-0.15px',
      titleM: '-0.15px',
      titleL: '-0.5px',
      titleXL: '-0.5px',
      title2XL: '-0.5px',
      title3XL: '-0.5px',
      title4XL: '-0.5px',
      title5XL: '-0.5px'
    }
  },
  ja: {
    fontFamily: 'Noto Sans JP',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  ko: {
    fontFamily: 'Noto Sans KR',
    letterSpacingAdjust: {
      bodyXS: '-0.25px',
      bodyS: '-0.25px',
      bodyM: '-0.25px',
      bodyL: '-0.5px',
      labelXS: '-0.25px',
      labelS: '-0.25px',
      labelM: '-0.25px',
      titleXS: '-0.25px',
      titleS: '-0.25px',
      titleM: '-0.25px',
      titleL: '-0.5px',
      titleXL: '-0.5px',
      title2XL: '-0.5px',
      title3XL: '-0.5px',
      title4XL: '-0.5px',
      title5XL: '-0.5px'
    }
  },
  ru: {
    fontFamily: 'Noto Sans',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  th: {
    fontFamily: 'Noto Sans Thai',
    letterSpacingAdjust: {
      bodyXS: '-0.25px',
      bodyS: '-0.25px',
      bodyM: '-0.25px',
      bodyL: '-0.5px',
      labelXS: '-0.25px',
      labelS: '-0.25px',
      labelM: '-0.25px',
      titleXS: '-0.25px',
      titleS: '-0.25px',
      titleM: '-0.25px',
      titleL: '-0.5px',
      titleXL: '-0.5px',
      title2XL: '-0.5px',
      title3XL: '-0.5px',
      title4XL: '-0.5px',
      title5XL: '-0.5px'
    }
  },
  uk: {
    fontFamily: 'Noto Sans',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  zh: {
    fontFamily: 'Noto Sans SC',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  'zh-CN': {
    fontFamily: 'Noto Sans SC',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  'zh-HK': {
    fontFamily: 'Noto Sans HK',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  'zh-TW': {
    fontFamily: 'Noto Sans TC',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  }
}

export const FALLBACK_FONT_LANGUAGES = new Set([
  'ar',
  'el',
  'he',
  'ja',
  'ko',
  'ru',
  'th',
  'uk',
  'zh-CN',
  'zh-HK',
  'zh-TW',
  'zh'
])

export const nonLatinFontFamilies = {
  ar: 'Noto Sans Arabic',
  el: 'Noto Sans',
  he: 'Noto Sans Hebrew',
  ja: 'Noto Sans JP',
  ko: 'Noto Sans KR',
  ru: 'Noto Sans',
  th: 'Noto Sans Thai',
  uk: 'Noto Sans',
  zh: 'Noto Sans SC',
  'zh-CN': 'Noto Sans SC',
  'zh-HK': 'Noto Sans HK',
  'zh-TW': 'Noto Sans TC'
}

export const fontFaces = {
  default: `
  @font-face {
    font-family: 'Campton';
    src: url('/assets/fonts/NeueCampton-Regular.woff2') format('woff2');
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: 'Campton';
    src: url('/assets/fonts/NeueCampton-Medium.woff2') format('woff2');
    font-style: normal;
    font-weight: 500;
  }

  @font-face {
    font-family: 'Campton';
    src: url('/assets/fonts/NeueCampton-SemiBold.woff2') format('woff2');
    font-style: normal;
    font-weight: 600;
  }

  @font-face {
    font-family: 'Campton';
    src: url('/assets/fonts/NeueCampton-Bold.woff2') format('woff2');
    font-style: normal;
    font-weight: 700;
  }
`
}
